export default "__VITE_ASSET__4902401a__"